import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-mdiicons',
	templateUrl:'./MDIIconsPluginCompPage.html',
	styles: [],
	styleUrls:['./MDIIconsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class MDIIconsPluginCompPage
{
	mdContent_1061 = `\`\`\`java
import com.jwebmp.plugins.materialicons.MDIIcons;
\`\`\``;
}
